import { AppCard } from "@/components/ui";
import { FileText } from "lucide-react";

type TNextStepsCardProps = {
  nextSteps?: string[] | null;
};

export function NextStepsCard({ nextSteps }: TNextStepsCardProps) {
  if (!nextSteps || nextSteps.length === 0) {
    return null;
  }

  return (
    <AppCard className="p-6">
      <div className="mb-4 flex items-center gap-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
          <FileText className="h-5 w-5 text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Next Steps</h3>
      </div>
      <ul className="space-y-4">
        {nextSteps.map((step, index) => (
          <li
            key={index}
            className="flex items-start gap-4"
          >
            <div className="mt-0.5 flex-shrink-0">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">
                {index + 1}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground">{step}</p>
          </li>
        ))}
      </ul>
    </AppCard>
  );
}
